import { useGetByTenantAssetListOrderAlertQuery } from '@/api/rtk-api'
import { plural } from '@/utilities/plural'

import { DEFAULT_QUERY } from '../assets-filter-list/orders-filter-context'
import classes from './orders-detail-empty-state.module.scss'

export const OrdersDetailEmptyState = () => {
  const { data, isLoading } = useGetByTenantAssetListOrderAlertQuery(DEFAULT_QUERY)

  if (isLoading) {
    return null
  }

  if (!data || data?.totalDocuments === 0) {
    return (
      <section className={classes.root}>
        <strong>0 assets found</strong>
        <p>Widen search criteria to find assets</p>
      </section>
    )
  }

  return (
    <section className={classes.root}>
      <strong>
        {data?.totalDocuments} {plural('asset', data?.totalDocuments)} found
      </strong>
      <p>Click on a asset to see more details</p>
    </section>
  )
}
